import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { AppPopupProps } from '../../interfaces_and_types';
import './styles.css';

const AppPopup: FC<AppPopupProps> = (props) => {
  const { t ,i18n } = useTranslation();

  return (
    <Popup
      position='center center'
      closeOnDocumentClick={false}
      closeOnEscape={false}
      modal
      open={props.open}
      className='popup'
      contentStyle={{
        padding: 5,
        borderRadius: 18,
        border: '1px solid #520989',
      }}
      lockScroll
    >
      <div className='popup_modal' style={{height: props.height, overflow: props.height ? 'scroll' : undefined}}>
        {props.xButton && (
          <button
            className='popup_modal_close'
            onClick={
              props.xButtonOnClick !== undefined
                ? props.xButtonOnClick
                : (event) => {
                    event.preventDefault();
                    props.setOpen(false);
                  }
            }
          >
            &times;
          </button>
        )}
        <div
          style={{
            fontFamily:
              i18n.language === 'ar'
                ? "'Cairo', sans-serif"
                : "'Rubik', sans-serif",
          }}
          className='popup_modal_header'
        >
          {' '}
          {t(props.title)}{' '}
        </div>
        {props.description !== undefined ? (
          <div
            style={{
              fontFamily:
                i18n.language === 'ar'
                  ? "'Cairo', sans-serif"
                  : "'Rubik', sans-serif",
            }}
            className='popup_modal_content'
          >
            {t(props.description)}
          </div>
        ) : (
          props.children
        )}
        <div
          style={{
            fontFamily:
              i18n.language === 'ar'
                ? "'Cairo', sans-serif"
                : "'Rubik', sans-serif",
          }}
          className='popup_modal_actions'
        >
          {props.choices}
        </div>
        {props.button1 && <button
          className='popup_modal_button1'
          onClick={async (e) => {
            e.preventDefault();
            props.button1OnClick !== undefined && props.button1OnClick();
            //console.log('clicked')
          }}
          style={{
            fontFamily:
              i18n.language === 'ar'
                ? "'Cairo', sans-serif"
                : "'Rubik', sans-serif",
          }}
        >
          {props.button1Title && t(props.button1Title)}
        </button>}
        {props.button2 && <button
          className='popup_modal_button1'
          onClick={async (e) => {
            e.preventDefault();
            props.button2OnClick !== undefined && props.button2OnClick();
            //console.log('clicked')
          }}
          style={{
            fontFamily:
              i18n.language === 'ar'
                ? "'Cairo', sans-serif"
                : "'Rubik', sans-serif",
          }}
        >
          {props.button2Title && t(props.button2Title)}
        </button>}
      </div>
    </Popup>
  );
};

export default AppPopup;
